import { render, staticRenderFns } from "./SessionDetailPlayerClues.vue?vue&type=template&id=f17c80cc&scoped=true&"
import script from "./SessionDetailPlayerClues.vue?vue&type=script&lang=js&"
export * from "./SessionDetailPlayerClues.vue?vue&type=script&lang=js&"
import style0 from "./SessionDetailPlayerClues.vue?vue&type=style&index=0&id=f17c80cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17c80cc",
  null
  
)

export default component.exports